<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="disassembleOrder.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="1100px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="disassembleOrder"
          :rules="ruleValidate"
          class="form"
          label-width="150px">
        <div class="vm-separate">
          <el-form-item label="申请编号">
            <el-input v-model="disassembleOrder.billNo" readonly placeholder="系统自动生成"/>
          </el-form-item>
          <el-form-item label="申请人">
            <el-input v-model="disassembleOrder.creatorName" readonly placeholder="系统自动生成"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="处理类型">
            <el-select v-model="disassembleOrder.dealType" clearable placeholder="请选择">
              <el-option
                  v-for="item in dealTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="退料单号">
            <el-input v-model="disassembleOrder.returnOrderNo" placeholder="请输入"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="出厂编号">
            <el-input v-model="disassembleOrder.factoryNo" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="拆解号">
            <el-input v-model="disassembleOrder.disassemblyNo" placeholder="请输入"/>
          </el-form-item>
        </div>
        <div style="padding: 0 0 10px 10px;width: 90%;margin: 0 auto">
          <div slot="toolbar">
            <el-button type="primary" style="margin-bottom: 10px" @click="addDetails">
              新建
            </el-button>
          </div>
          <el-table
              :data="disassembleOrder.details"
              border>
            <el-table-column prop="materialNo" width="160" align="center" label="物料编号">
              <template slot-scope="scope">
                <el-input v-model="scope.row.materialNo" placeholder="请输入">
                  <el-button slot="append" icon="el-icon-search" @click="openMaterialSelectDialog(scope.$index)"/>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="materialName" align="center" label="物料名称">
              <template slot-scope="scope">
                <el-input v-model="scope.row.materialName" placeholder="请输入" autosize type="textarea"/>
              </template>
            </el-table-column>
            <el-table-column prop="quantity" width="100" align="center" label="数量">
              <template slot-scope="scope">
                <el-input v-model="scope.row.quantity" placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="unit" width="100" align="center" label="单位">
              <template slot-scope="scope">
                <el-input v-model="scope.row.unit" placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                align="center"
                class-name="vm-table_operate"
                width="100px">
              <template slot-scope="scope">
                <el-button type="danger" @click="oneDelete(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <material-c-s-select ref="selectMaterial" @select="getDetails"/>
        </div>
        <div>
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            附件
          </div>
          <div>
            <el-upload
                action=""
                multiple
                :http-request="submitUpload"
                :show-file-list="false"
                :disabled="uploadLoading"
                style="display: inline-block; float: left; margin: 5px;">
              <el-button type="primary" plain>
                <i class="el-icon-upload el-icon--right"/>
                附件上传
              </el-button>
            </el-upload>
          </div>
          <el-table
              v-if="disassembleOrder.attachments"
              ref="payData"
              :data="disassembleOrder.attachments">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="fileName" align="center" label="图片">
              <template slot-scope="scope">
                <el-image
                    style="width: 50px; height: 50px;margin-right: 10px"
                    :src="scope.row.imgUrl"
                    :preview-src-list="imgUrls"/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件描述">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.fileName"
                    class="tabInput"
                    style="width: 400px;margin: 0 auto;text-align: center"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
              <template slot-scope="scope">
                <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSave">保存</el-button>
        <el-button :loading="submitLoading" type="success" @click="handleSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import auth from "@/util/loginUtil";
  import constant from "@/util/constant";
  import MaterialCSSelect from "@/views/afterSalesManagement/Replacement/MaterialCSSelect";

  export default {
    name: "DisassembleOrderEdit",
    components: {MaterialCSSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        uploadLoading: false,
        selection: [],
        imgUrls: [],
        dealTypes: constant.toSelect(constant.dealType),
        disassembleOrder: {
          pkid: "",
          billNo: "",
          returnOrderNo: "",
          factoryNo: "",
          isSubmit: false,
          disassemblyNo: "",
          creatorName: auth.getName(),
          details: [],
          attachments: [],
        },
        ruleValidate: {
          // cause: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.disassembleOrder.pkid = id;
        this.dialogVisible = true;
        if (id > 0) {
          this.$nextTick(() => {
            this.getData();
          });
        }
      },
      select(selection) {
        this.selection = selection;
        this.index = [];
        for (let item of this.selection) {
          this.index.push((item.departmentNo / 10) - 1);
        }
      },
      getDetails(row, index) {
        console.log(row, index);
        this.disassembleOrder.details[index].materialId = row.id;
        this.disassembleOrder.details[index].materialName = row.name;
        this.disassembleOrder.details[index].materialNo = row.no;
      },
      addDetails() {
        this.disassembleOrder.details.push({
          pkid: 0,
          masterId: 0,
          materialId: -1,
          materialName: "",
          materialNo: "",
          quantity: 0,
          unit: "",
        });
      },
      fileDelete(row, index) {
        this.disassembleOrder.attachments.splice(index, 1);
      },
      oneDelete(index) {
        this.disassembleOrder.details.splice(index, 1);
      },
      openMaterialSelectDialog(index) {
        this.$refs.selectMaterial.open(index);
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.disassembleOrder.attachments.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.disassembleOrder.attachments.forEach(row => {
              if (row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              } else {
                row.imgUrl = "https://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      getData() {
        this.$http
          .get("basic", `disassembleOrders/${this.disassembleOrder.pkid}`)
          .then(resp => {
            this.disassembleOrder = resp;
            this.disassembleOrder.attachments.forEach(row=>{
              if(row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              }else {
                row.imgUrl = "https://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
          });
      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      // beforeAvatarUpload(file) {
      //   return this.$confirm(`确定移除 ${ file.name }？`);
      // },
      handleSuccess(response, file, fileList) {
        file.path = response;
        this.files = fileList;
        let object = {
          fileName: file.path.originalName,
          filePath: file.path.fullPath,
        };
        this.disassembleOrder.attachments.push(object);
      },
      handleSubmit() {
        this.disassembleOrder.isSubmit = true;
        if (this.disassembleOrder.pkid > 0) {
          this.handleSubmitUpData();
        } else {
          this.handleSubmitSave();
        }
      },
      handleSave() {
        if (this.disassembleOrder.pkid > 0) {
          this.handleSubmitUpData();
        } else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "disassembleOrders", this.disassembleOrder)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "disassembleOrders", this.disassembleOrder)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
